<template>
  <div class="ma-5 role-approve-main">
    <div class="manage-department-title title-notab pt-4 pb-4">
    รายการสิทธิ์อนุมัติ
    </div>
    <v-row class="pt-8">
    <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">ค้นหา</span>
        <v-text-field
          v-model="keywordSearch"
          item-text="groupCompanyNameFull"
          item-value="groupCompanyId"
          multiple
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="Search"
          no-data-text="ไม่พบข้อมูล"
          @change="getData()"
          @click:clear="keywordSearch='', getData()"
        >
          <template v-slot:append>
            <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="getData()">
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <span class="head-search-text">บริษัท</span>
        <v-autocomplete
          v-model="selectedCompany"
          :items="itemCompanys"
          item-text="companyFullNameTh"
          item-value="_id"
          outlined
          dense
          clearable
          class="mt-2"
          placeholder="เลือกบริษัท"
          no-data-text="ไม่พบข้อมูล"
          @change="getData()"
          @click:clear="selectedCompany='', getData()"
        >
        </v-autocomplete>
      </v-col>
      <v-spacer/>
      <v-btn
        elevation="0"
        dark
        class="button-color mr-3 mt-8"
        right
        bottom
        @click="goToCreate()"
      >
        <v-icon left size="14px">
          mdi-plus
        </v-icon>
        สร้างสิทธิ์
      </v-btn>
    </v-row>
    <div class="ma-3">
      <v-row>
        <span>แสดงรายการทั้งหมด {{ totalgroupCount }} รายการ</span>
      </v-row>
    </div>
      <v-row justify="space-around" align="center" v-if="data.length==0" v-show="!loading">
        <div style="margin-top: 10vh;">
          <img width="150" height="110" src="@/assets/icons/emp-data-icon2.png">
          <br>
          <span class="black--text text-darken-4 mt-1 mb-1 ml-2">ไม่มีข้อมูลสิทธิ์อนุมัติ</span>
          </div>
      </v-row>
      <v-row
        v-else
        class="mt-5"
        v-for="(itemGroupCompany) in data"
        :key="itemGroupCompany._id"
      >
        <v-col cols="12" >
          <span class="head-search-text" style="font-size: 16px;">เครือบริษัท :  {{ itemGroupCompany.groupCompanyNameTh }}</span>
        </v-col>
        <v-col cols="12" style="margin-top: -20px;">
          <v-divider></v-divider>
          <v-row class="mt-3">
            <v-col
              cols="6" sm="6" md="4" lg="3"
              v-for="(itemCompany, i) in itemGroupCompany.children"
              :key="itemCompany._id"
            >
              <v-hover v-slot="{ hover }" v-show="itemGroupCompany.isExpand ? true: i < 8">
                <v-card
                  hover
                  class="pa-2 pt-3 text-center role-select rounded-lg"
                  rounded
                  :elevation="hover ? 4 : 0"
                  :style="`cursor: pointer; border: 1px solid ${hover? '#1654C6':'#C7C7C7'}; background-color: ${hover? '#EFF4FD':'white'};`"
                  width="auto"
                  height="200"
                  @click="goToCompany(itemCompany)"
                >
                  <div class="mb-2" style="height: 30px;">
                  <span class="head-search-text" style="color: black; overflow-wrap: break-word;">{{ itemCompany.companyFullNameTh }}</span>
                  </div>
                  <v-avatar
                    size="70"
                    class="mt-2"
                    style="border: 1px solid #C7C7C7; background-color: white;"
                  >
                    <v-img
                      v-if="itemCompany.companyImage !== ''"
                      contain
                      :src="!itemCompany.companyImage ? require('@/assets/icons/no_company.png') : `${apiServer}/api/vMonk/companys/getcompanyFileById/${itemCompany.companyImage}`"
                      aspect-ratio="1.7"
                    />
                    <v-img
                      v-else
                      contain
                      :lazy-src="require('@/assets/icons/no_company.png')"
                      :src="require('@/assets/icons/no_company.png')"
                      aspect-ratio="2.7"
                    />
                  </v-avatar>
                  <br>
                  <v-row class="text-center justify-center mt-3">
                    <v-card
                      width="62"
                      height="38"
                      elevation="0"
                      :style="`border: 1px solid #E0E0E0; border-radius: 6px 0 0 6px;`"
                      class="d-flex align-center justify-center"
                    >
                      <span class="head-search-text" style="color: black;">สิทธิ์</span>
                    </v-card>
                    <v-card
                      width="62"
                      height="38"
                      elevation="0"
                      color="#EFF4FD"
                      :style="`border: 1px solid ${hover? '#1654C6':'#E0EAFB'}; border-radius: 0 6px 6px 0;`"
                      class="d-flex align-center justify-center"
                    >
                      <span style="color: blue; font-size: 22px; font-weight: bold; margin-top: -4px">{{itemCompany.totolApproveRight || 0}}</span>
                    </v-card>
                  </v-row>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" style="margin-top: -15px;" justify="center" align="center" class="ml-0 mr-0 mb-0 pa-0" v-show="itemGroupCompany.children.length > 8">
          <v-btn text v-if="itemGroupCompany.isExpand === false" @click="itemGroupCompany.isExpand = !itemGroupCompany.isExpand" style="color: #3776E9; cursor: pointer;">ดูเพิ่มเติม<v-icon left dark color="primary" size="">mdi-chevron-down</v-icon></v-btn>
          <v-btn text v-else @click="clickExpand(itemGroupCompany)" style="color: #3776E9; cursor: pointer;">แสดงน้อยลง<v-icon left dark color="primary" size="">mdi-chevron-up</v-icon></v-btn>
        </v-col>
      </v-row>
      <OverlayLoading :loading="loading" />
  </div>
</template>

<script>
import OverlayLoading from '../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
const axios = require('axios')

export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      apiServer: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      keywordSearch: '',
      selectedCompany: '',
      itemCompanys: [],
      totalgroupCount: 0,
      data: [],
      loading: false
    }
  },
  beforeDestroy () {
    EventBus.$off('tabstitletructure')
  },
  mounted () {
    EventBus.$on('tabstitletructure', this.getDataTab)
  },
  async created () {
    await this.getData()
  },
  methods: {
    async goToCreate () {
      this.$router.push('/manageroleapprover/create')
    },
    async getData () {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/right/dashboard`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          },
          data: {
            search: this.keywordSearch,
            companyId: this.selectedCompany
          }
        })
          .then((response) => {
            if (response.data.success === true) {
              var tempData = response.data.result.result
              tempData.map(e => { e.isExpand = false })
              this.data = JSON.parse(JSON.stringify(tempData))
              this.totalgroupCount = response.data.result.total || 0
              this.itemCompanys = response.data.selector
            } else {
              this.data = []
              this.totalgroupCount = 0
              this.itemCompanys = []
            }
          })
          .catch(function (thrown) {
          })
      } catch (error) { } finally {
        this.loading = false
      }
    },
    async getCompanyImage (companyImage) {
      if (companyImage !== '') {
        return `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/companys/getcompanyFileById/` + companyImage
      }
    },
    createRoleApprover () {
    },
    async goToCompany (data) {
      const params = await this.encode(data)
      this.$router.push('/manageroleapprover/c/' + params)
    },
    async encode (data) {
      var params = btoa(JSON.stringify({ companyid: data._id, groupid: data.groupCompanyId }))
      return params
    },
    async clickExpand (item) {
      var focusItem = this.data.find(e => e._id === item._id)
      focusItem.isExpand = !focusItem.isExpand
      // console.log(focusItem.isExpand)
    }
  }
}
</script>

<style scoped>
.role-approve-main >>> .disable-events {
    pointer-events: none
  }

 .role-approve-main >>>  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  color: fuchsia !important;
}
</style>
